var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component, Watch } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import GlobalVue from "../../globalVue";
import SalesReportService from '../../api/SalesReportService';
import Header from "./components/Header.vue";
import SubTable from "./components/SubTable.vue";
import { getTheDayZeroTime } from '../../helper/util';
import TableHeaderToolTip from '../purchaseOrderForUpperSup/components/TableHeaderToolTip.vue';
import SummaryDepotList from './SummaryDepotList.vue';
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isReady = false;
        _this.listData = [];
        _this.tableData = [];
        _this.total = 0;
        _this.searchParams = null;
        _this.selectRows = [];
        _this.tableHeight = 300;
        _this.formData = {};
        _this.filter = {
            viewType: 0
        };
        _this.order_money_count = 0;
        _this.order_amount_count = 0;
        _this.pending_order_money_count = 0;
        _this.cost_money_count = 0;
        _this.gross_profit_count = 0;
        _this.gross_margin = 0;
        _this.gross_margin_count = 0;
        _this.refund_ratio = 0;
        _this.refund_count = 0;
        _this.refund_amount_count = 0;
        _this.refund_money_total = 0;
        _this.pending_refund_money_total = 0;
        _this.after_amount_count = 0;
        _this.refund_amount = 0;
        _this.refund_money = 0;
        _this.order_loss_amount = 0;
        _this.order_loss_money = 0;
        _this.order_warehousing_amount = 0;
        _this.order_warehousing_money = 0;
        _this.showSummary = true;
        _this.current_business_id = 0;
        _this.expand = {};
        return _this;
    }
    List.prototype.fieldIdChange = function () {
        var _this = this;
        this.isReady = false;
        this.$nextTick(function () {
            _this.isReady = true;
        });
    };
    List.prototype.created = function () {
        this.service = SalesReportService.getInstance();
    };
    List.prototype.mounted = function () {
        var _this = this;
        this.tableHeight = document.documentElement.clientHeight - 240;
        this.$nextTick(function () {
            _this.isReady = true;
        });
    };
    List.prototype.closeTab = function () {
        var closeBtnArr = $(".navTabsCloseBtn").prev();
        for (var i = 0; i < closeBtnArr.length; i++) {
            if ($(closeBtnArr[i])[0].innerText == "销售汇总详情") {
                console.log($(closeBtnArr[i]).next());
                $(closeBtnArr[i]).next().click();
            }
        }
    };
    List.prototype.toDetail = function (row) {
        this.closeTab();
        if (this.filter.viewType == 1) {
            this.addTab({
                component: SummaryDepotList,
                title: '销售汇总详情',
                showExist: true,
                name: 'summary_depot_list' + row.depot_id,
                cprops: {
                    depot_id: row.depot_id,
                    depot_name: row.depot_name,
                    organ_name: row.organ_name,
                    listFilter: this.filter,
                    viewType: this.filter.viewType,
                },
            });
            window._czc.push(['_trackEvent', '销售汇总', '跳转按仓库查询详情']);
        }
        if (this.filter.viewType == 2) {
            localStorage.setItem("goodsType", row.goods_type_id);
            this.addTab({
                component: SummaryDepotList,
                title: '销售汇总详情',
                showExist: true,
                name: 'summary_depot_list' + row.goods_type_id,
                cprops: {
                    depot_id: "",
                    listFilter: this.filter,
                    viewType: this.filter.viewType,
                    goodsType: row.goods_type_name,
                    goods_type_id: row.goods_type_id,
                },
            });
            window._czc.push(['_trackEvent', '销售汇总', '跳转按货品类别查询详情']);
        }
        if (this.filter.viewType == 3) {
            sessionStorage.setItem("GOODITEM", JSON.stringify(row));
            localStorage.setItem("goodId", row.supplier_goods_id);
            this.addTab({
                component: SummaryDepotList,
                title: '销售汇总详情',
                showExist: true,
                name: 'summary_depot_list' + row.supplier_goods_id,
                cprops: {
                    depot_id: "",
                    listFilter: this.filter,
                    viewType: this.filter.viewType,
                    good: row.supplier_goods_id,
                    row: row,
                },
            });
            window._czc.push(['_trackEvent', '销售汇总', '跳转按货品查询详情']);
        }
    };
    List.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (_.isDate(filter.s_time) || _.isDate(filter.e_time)) {
            filter.s_time = filter.s_time && filter.s_time.format('yyyy-MM-dd');
            filter.e_time = filter.e_time && filter.e_time.format('yyyy-MM-dd');
        }
        if (!filter.s_time) {
            this.$message.error('请选择开始时间');
            return;
        }
        if (!filter.e_time) {
            this.$message.error('请选择结束时间');
            return;
        }
        var timeDiff = getTheDayZeroTime(new Date(filter.e_time)) - getTheDayZeroTime(new Date(filter.s_time));
        if (timeDiff < 0 || timeDiff > 365 * 1000 * 24 * 60 * 60) {
            this.$message.warning("最大查询范围不可超过一年");
            return;
        }
        this.filter = filter;
        this.getList();
    };
    List.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var serviceList = [
            {
                url: "getSummaryList",
            },
            {
                url: "getSummaryDepotList",
            },
            {
                url: "getGoodsCategoryList",
            },
            {
                url: "getGoodsList",
            }
        ];
        localStorage.setItem("viewType", this.filter.viewType);
        var loadingInstance = Loading.service({ fullscreen: true });
        var serviceUrl = serviceList[this.filter.viewType].url;
        this.service[serviceUrl](Object.assign({}, this.filter, __assign({}, pager, { sort_field: this.order ? this.order[0] : null, sort_type: this.order ? this.order[1] : null }))).then(function (res) {
            var data = res.data || {};
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.listData.forEach(function (item) {
                item['tableData'] = [];
            });
            _this.total = data.total;
            _this.order_money_count = data.order_money_count || 0;
            _this.order_amount_count = data.order_amount_count || 0;
            _this.pending_order_money_count = data.pending_order_money_count || 0;
            _this.cost_money_count = data.cost_money_count || 0;
            _this.gross_profit_count = data.gross_profit_count || 0;
            _this.gross_margin = data.gross_margin || 0;
            _this.gross_margin_count = data.gross_margin_count || 0;
            _this.refund_count = data.refund_count || 0;
            _this.refund_amount_count = data.refund_amount_count || 0;
            _this.refund_money_total = data.refund_money_total || 0;
            _this.after_amount_count = data.after_amount_count || 0;
            _this.pending_refund_money_total = data.pending_refund_money_total || 0;
            _this.refund_money = data.refund_money || 0;
            _this.refund_amount = data.refund_amount || 0;
            _this.refund_ratio = data.refund_ratio || 0;
            _this.order_loss_amount = data.order_loss_amount || 0;
            _this.order_loss_money = data.order_loss_money || 0;
            _this.order_warehousing_amount = data.order_warehousing_amount || 0;
            _this.order_warehousing_money = data.order_warehousing_money || 0;
            _this.resizeTable();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    List.prototype.resizeTable = function () {
        var _this = this;
        this.$nextTick(function () {
            var ref = _this.filter.viewType ? 'table1' : 'table2';
            console.log('(this.$refs[ref] as any)>>>', _this.$refs[ref]);
            _this.$refs[ref].doLayout();
        });
    };
    List.prototype.expandChange = function (row, expandedRows) {
        var _this = this;
        if (expandedRows.length == 0) {
            return;
        }
        var params = {
            business_id: row.business_id,
            supplier_to_business_id: row.supplier_to_business_id,
            organ_id: row.organ_id,
            from: this.filter.from,
            order_type: this.filter.order_type,
            time_type: this.filter.time_type,
            s_time: this.filter.s_time,
            e_time: this.filter.e_time,
        };
        var index = this.listData.indexOf(row);
        this.service.getSummaryShopList(params).then(function (res) {
            if (res.data && res.data.success) {
                var tableData = res.data.data;
                tableData.forEach(function (item, idx) {
                    GlobalVue.$set(_this.listData[index].tableData, idx, item);
                });
                GlobalVue.$set(_this.listData[index].tableData, "business_id", params.business_id);
                var data = res.data;
                _this.expand[params.business_id] = {
                    "expand_order_money_count": data.order_money_count || 0,
                    "expand_order_amount_count": data.order_amount_count || 0,
                    "expand_pending_order_money_count": data.pending_order_money_count || 0,
                    "expand_cost_money_count": data.cost_money_count || 0,
                    "expand_gross_profit_count": data.gross_profit_count || 0,
                    "expand_refund_count": data.refund_count || 0,
                    "expand_refund_amount_count": data.refund_amount_count || 0,
                    "expand_after_amount_count": data.after_amount_count || 0,
                    "expand_refund_money_total": data.refund_money_total || 0,
                    "expand_pending_refund_money_total": data.pending_refund_money_total || 0,
                };
                _this.current_business_id = params.business_id;
                console.log(_this.expand);
                console.log(_this.current_business_id);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    List.prototype.pageChange = function (pager) {
        this.getList();
    };
    List.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    List.prototype.getSummaries = function (param) {
        var _this = this;
        this.tableParam = param;
        var sums;
        var columns = param.columns, data = param.data;
        console.log('columns====>', param);
        if (this.filter.viewType == 0) {
            if (this.filter.order_type == 5) {
                sums = ['合计', ''];
                columns.forEach(function (column) {
                    console.log(column);
                    if (column.label == '客户' || column.property == 'business_name') {
                        sums.push('');
                    }
                    else if (column.label == '退货&退款次数' || column.property == 'refund_count') {
                        sums.push(_this.refund_count);
                    }
                    else if (column.label == '已退金额' || column.property == 'refund_money') {
                        sums.push(_this.refund_money_total);
                    }
                    else if (column.label == '待退金额' || column.property == 'pending_refund_money') {
                        sums.push(_this.pending_refund_money_total);
                    }
                });
            }
            else {
                sums = [
                    '合计',
                    '',
                ];
                if (this.openedCodeData.isOpenMultOrg) {
                    sums.push('');
                }
                columns.forEach(function (column) {
                    console.log(column);
                    if (column.label == '客户' || column.property == 'business_name') {
                        sums.push('');
                    }
                    else if (column.label == '门店' || column.property == 'shop_name') {
                        sums.push('');
                    }
                    else if (column.label == '实际销售量' || column.property == 'after_amount') {
                        sums.push(_this.after_amount_count);
                    }
                    else if (column.label == '成本金额' || column.property == 'cost_money') {
                        sums.push(_this.cost_money_count);
                    }
                    else if (column.label == '销售量' || column.property == 'order_amount') {
                        sums.push(_this.order_amount_count);
                    }
                    else if (column.label == '退货量' || column.property == 'refund_amount') {
                        sums.push(_this.refund_amount_count);
                    }
                    else if (column.label == '销售金额' || column.property == 'order_money') {
                        sums.push(_this.order_money_count);
                    }
                    else if (column.label == '毛利额' || column.property == 'gross_profit') {
                        sums.push(_this.gross_profit_count);
                    }
                    else if (column.label == '待收金额' || column.property == 'pending_order_money') {
                        sums.push(_this.pending_order_money_count);
                    }
                });
            }
        }
        else if (this.filter.viewType == 1) {
            if (this.filter.order_type == 5) {
                sums = ['合计'];
                columns.forEach(function (column) {
                    console.log(column);
                    if (column.label == '仓库名称' || column.property == 'depot_name') {
                        sums.push('');
                    }
                    else if (column.label == '退货数量' || column.property == 'refund_amount') {
                        sums.push(_this.refund_amount_count);
                    }
                    else if (column.label == '报损数量' || column.property == 'order_loss_amount') {
                        sums.push(_this.order_loss_amount);
                    }
                    else if (column.label == '入库数量' || column.property == 'order_warehousing_amount') {
                        sums.push(_this.order_warehousing_amount);
                    }
                    else if (column.label == '退货入库总值' || column.property == 'order_warehousing_money') {
                        sums.push(_this.order_warehousing_amount);
                    }
                });
            }
            else {
                sums = ['合计'];
                columns.forEach(function (column) {
                    console.log(column);
                    if (column.label == '仓库名称' || column.property == 'depot_name') {
                        sums.push('');
                    }
                    else if (column.label == '销售量' || column.property == 'order_amount') {
                        sums.push(_this.order_amount_count);
                    }
                    else if (column.label == '退货量' || column.property == 'refund_amount') {
                        sums.push(_this.refund_amount_count);
                    }
                    else if (column.label == '实际销售量' || column.property == 'after_amount') {
                        sums.push(_this.after_amount_count);
                    }
                    else if (column.label == '销售成本' || column.property == 'cost_money') {
                        sums.push(_this.cost_money_count);
                    }
                    else if (column.label == '销售金额' || column.property == 'order_money') {
                        sums.push(_this.order_money_count);
                    }
                    else if (column.label == '毛利额' || column.property == 'gross_profit') {
                        sums.push(_this.gross_profit_count);
                    }
                    else if (column.label == '毛利率(%)' || column.property == 'gross_margin') {
                        sums.push(_this.gross_margin);
                    }
                });
            }
        }
        else if (this.filter.viewType == 2) {
            if (this.filter.order_type == 5) {
                sums = ['合计'];
                columns.forEach(function (column) {
                    console.log(column);
                    if (column.label == '货品类别' || column.property == 'goods_type_name') {
                        sums.push('');
                    }
                    else if (column.label == '退货数量' || column.property == 'refund_amount') {
                        sums.push(_this.refund_amount_count);
                    }
                    else if (column.label == '退货金额' || column.property == 'refund_money') {
                        sums.push(_this.refund_money_total);
                    }
                    else if (column.label == '退货率' || column.property == 'refund_ratio') {
                        sums.push(_this.refund_ratio + '%');
                    }
                });
            }
            else {
                sums = ['合计'];
                columns.forEach(function (column) {
                    console.log(column);
                    if (column.label == '货品类别' || column.property == 'goods_type_name') {
                        sums.push('');
                    }
                    else if (column.label == '销售量' || column.property == 'order_amount') {
                        sums.push(_this.order_amount_count);
                    }
                    else if (column.label == '退货量' || column.property == 'refund_amount') {
                        sums.push(_this.refund_amount_count);
                    }
                    else if (column.label == '实际销售量' || column.property == 'after_amount') {
                        sums.push(_this.after_amount_count);
                    }
                    else if (column.label == '销售成本' || column.property == 'cost_money') {
                        sums.push(_this.cost_money_count);
                    }
                    else if (column.label == '销售金额' || column.property == 'order_money') {
                        sums.push(_this.order_money_count);
                    }
                    else if (column.label == '毛利额' || column.property == 'gross_profit') {
                        sums.push(_this.gross_profit_count);
                    }
                    else if (column.label == '毛利率(%)' || column.property == 'gross_margin') {
                        sums.push(_this.gross_margin);
                    }
                });
            }
        }
        else if (this.filter.viewType == 3) {
            sums = ['合计'];
            columns.forEach(function (column) {
                console.log(column);
                if (column.label == '货品名称' || column.property == 'supplier_goods_name') {
                    sums.push('');
                }
                else if (column.label == '规格' || column.property == 'goods_format_name') {
                    sums.push('');
                }
                else if (column.label == '销售量' || column.property == 'order_amount') {
                    sums.push(_this.order_amount_count);
                }
                else if (column.label == '退货量' || column.property == 'refund_amount') {
                    sums.push(_this.refund_amount_count);
                }
                else if (column.label == '实际销售量' || column.property == 'after_amount') {
                    sums.push(_this.after_amount_count);
                }
                else if (column.label == '销售成本' || column.property == 'cost_money') {
                    sums.push(_this.cost_money_count);
                }
                else if (column.label == '销售金额' || column.property == 'order_money') {
                    sums.push(_this.order_money_count);
                }
                else if (column.label == '毛利额' || column.property == 'gross_profit') {
                    sums.push(_this.gross_profit_count);
                }
                else if (column.label == '毛利率(%)' || column.property == 'gross_margin') {
                    sums.push(_this.gross_margin);
                }
            });
        }
        return sums;
    };
    List.prototype.getDetailSummaries = function (param) {
        var sums;
        if (param.data.length == 0 || this.expand[param.data.business_id] == undefined) {
            console.log(param.data.business_id);
            console.log(this.current_business_id);
            return [''];
        }
        var data = this.expand[param.data.business_id];
        if (this.filter.viewType == 0) {
            if (this.filter.order_type == 5) {
                sums = [
                    '小计',
                    data.expand_refund_count,
                    data.expand_refund_money_total,
                    data.expand_pending_refund_money_total,
                ];
            }
            else {
                sums = [
                    '小计',
                    data.expand_order_amount_count,
                    data.expand_refund_amount_count,
                    data.expand_after_amount_count,
                    data.expand_cost_money_count,
                    data.expand_order_money_count,
                    data.expand_gross_profit_count,
                    data.expand_pending_order_money_count,
                ];
            }
        }
        return sums;
    };
    __decorate([
        Watch("getPageFieldId")
    ], List.prototype, "fieldIdChange", null);
    List = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user",
                openedCodeData: 'openedCodeData'
            }), { getPageFieldId: function () {
                    var id = 111;
                    if (0 == this.filter.viewType) {
                        if (5 == this.filter.order_type) {
                            id = 115;
                        }
                        else {
                            id = 111;
                        }
                    }
                    else if (1 == this.filter.viewType) {
                        if (5 == this.filter.order_type) {
                            id = 116;
                        }
                        else {
                            id = 112;
                        }
                    }
                    else if (2 == this.filter.viewType) {
                        if (5 == this.filter.order_type) {
                            id = 117;
                        }
                        else {
                            id = 113;
                        }
                    }
                    else if (3 == this.filter.viewType) {
                        id = 114;
                    }
                    return id;
                } }),
            components: {
                'list-header': Header,
                'sub-table': SubTable,
                TableHeaderToolTip: TableHeaderToolTip,
            },
            methods: {
                renderHeader1: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: '毛利额 = 销售金额 -  销售成本',
                            placement: 'bottom',
                        },
                    }, '毛利额');
                },
                renderHeader2: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: '毛利率 = （销售金额 -  销售成本）/ 销售金额x100%',
                            placement: 'bottom',
                        },
                    }, '毛利率(%)');
                },
            },
        })
    ], List);
    return List;
}(Vue));
export default List;
